import Box from '@mui/material/Box'
import Dialog from '@mui/material/Dialog'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useTranslate } from '@repo/unicity'
import { ReCaptchaV2 } from './recaptcha-v2.component'
import warningIcon from './assets/warning.svg'

type ReCaptchaV2ModalProps = {
    open: boolean
    language: string
    onClose: () => void
    onVerified: () => void
    hint?: string
}

export const ReCaptchaV2Modal = ({ open, language, onClose, onVerified, hint }: ReCaptchaV2ModalProps) => {
    const { translate } = useTranslate()

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            disableEnforceFocus
            disableAutoFocus
            PaperProps={{
                sx: {
                    maxWidth: 540,
                    borderRadius: '8px',
                    background: '#ffffff'
                }
            }}
            data-testid="recaptcha-v2-modal">
            <Stack
                sx={{
                    px: { xs: 3, md: '70px' },
                    py: 5,
                    alignItems: 'center'
                }}>
                <Box component="img" src={warningIcon} alt="" sx={{ width: 79, height: 78 }} />

                <Typography
                    mt="40px"
                    sx={{
                        fontSize: '24px',
                        fontWeight: 700,
                        color: '#003B6F',
                        textAlign: 'center',
                        lineHeight: '25px'
                    }}>
                    {translate('Oops')}
                </Typography>

                <Typography
                    mt="24px"
                    variant="caption"
                    sx={{
                        fontSize: '16px',
                        color: '#8A9BB0',
                        fontWeight: 400,
                        lineHeight: '20px',
                        textAlign: 'center'
                    }}>
                    {translate('desc_modal_recaptchaV2')}
                </Typography>

                {hint && (
                    <Typography
                        mt="16px"
                        sx={{
                            fontSize: '14px',
                            fontWeight: 500,
                            color: '#003B6F',
                            lineHeight: '20px',
                            textAlign: 'center'
                        }}>
                        {hint}
                    </Typography>
                )}

                <Box mt="40px">
                    <ReCaptchaV2 language={language} onVerified={onVerified} />
                </Box>
            </Stack>
        </Dialog>
    )
}
